import { isArray, isString } from 'lodash';
import * as actionTypes from './metaAttachActionTypes';
import * as pictionUtils from '../utils/piction';
import { SearchParams } from '../utils/searchUtils';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';

export const addMetadata = metadata => ({
  type: actionTypes.META_ATTACH_ADD,
  metadata,
});

export const clearMetadata = () => ({
  type: actionTypes.META_ATTACH_CLEAR,
});

export const metaAttachRequest = () => ({
  type: actionTypes.META_ATTACH_REQUEST,
});

export const metaAttachSuccess = () => ({
  type: actionTypes.META_ATTACH_SUCCESS,
});

export const metaAttachFailure = err => ({
  type: actionTypes.META_ATTACH_FAILURE,
  err,
});

export const metaAttach = (metadata, umoIDList, isReplace = false, searchParams, intl) =>
  function metaAttachDispatch(dispatch) {
    dispatch(metaAttachRequest());

    let newUMOList = isArray(umoIDList) ? umoIDList : [umoIDList];

    let searchQuery;

    if (searchParams instanceof SearchParams) {
      searchQuery = searchParams.toSearchQuery();
    } else if (isString(searchParams)) {
      searchQuery = searchParams;
    }

    const promise = pictionUtils.metaAttach(metadata, newUMOList, isReplace, intl, searchQuery);

    return promise
      .then((res) => {
        dispatch(metaAttachSuccess());
        return { res };
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(metaAttachFailure(err));
        }
        return err;
      });
  };



// WEBPACK FOOTER //
// ./src/js/actions/metaAttach.js